export default {
  namespaced: true,
  state: {
    mostradoPagos: JSON.parse(localStorage.getItem('mostradoPagos')) || false,
  },
  mutations: {
    setMostradoPagos(state, value) {
      state.mostradoPagos = value;

      localStorage.setItem('mostradoPagos', JSON.stringify(value));
    },
  },
  actions: {
    setMostradoPagos({ commit }, value) {
      commit('setMostradoPagos', value);
    },
  },
  getters: {
    permisosInternacionalizacion(state, getters, rootState) {
      return (
        rootState.CARGO.id == 26 || // EJECUTIVO GESTIÓN EMPRESARIAL
        rootState.DATA_USER.id == 9029 || // GARDILCIC FLORES DINKA RAHIZA
        rootState.DATA_USER.id == 59487 // AMERICO ITAMAR ECHALAR GUZMAN
      );
    },
    getMostradoPagos: (state) => state.mostradoPagos,
    permisosResponsablesAdmisiones(state, getters, rootState) {
      return (
        rootState.CARGO.id == 1 || // MASTER
        rootState.DATA_USER.id == 65011 || // Flores Sanabria Sonia
        rootState.DATA_USER.id == 127999 || // Lozano Maraz Mirtha Fatima
        rootState.DATA_USER.id == 70413 || // Poma Mamani Jeaneth
        rootState.DATA_USER.id == 25406 || // Soliz Michel Laura Patricia
        rootState.DATA_USER.id == 14412 || // Martinez Flores Luis Santos
        rootState.DATA_USER.id == 6608 || // Lino Segovia Eduardo Luis
        rootState.DATA_USER.id == 173669 || // Perez Murry Marcela
        rootState.DATA_USER.id == 154092 || // Caero Ramos Gabriela
        rootState.DATA_USER.id == 62081 || // Villarroel Ingrid Pamela
        rootState.DATA_USER.id == 51124 || // Eguez Davila Joanna Sthefany
        rootState.DATA_USER.id == 2123 || // Peñaranda Ordoñez Andreina Elena
        rootState.DATA_USER.id == 7983 || // Espinoza Colque Flabia Roxana
        rootState.DATA_USER.id == 78495 || // Echalar Galean Nelva Fany
        rootState.DATA_USER.id == 1331 || // Victoria Mendoza Carmen Julia
        rootState.DATA_USER.id == 62097 || // Colque Cuellar Shirley Tatiana
        rootState.DATA_USER.id == 26471 || // Estrada Pacara Justina
        rootState.DATA_USER.id == 12065 || // Aramayo Martinez Andrea Lucia
        rootState.DATA_USER.id == 9394 || // Cruz Riva Jose Alejandro
        rootState.DATA_USER.id == 18622 || // Quezada Castellón Shauny
        rootState.DATA_USER.id == 154651 || // Rocha Saravia Irina
        rootState.DATA_USER.id == 9845 || // Rodriguez Flores Alejandra Lili
        rootState.DATA_USER.id == 37966 || // Lopez Zapata Rosemary
        rootState.DATA_USER.id == 152838 || // Ayala Gorostiaga Camila Valentina
        rootState.DATA_USER.id == 12988 || // Muñoz Paula María De Los Ángeles
        rootState.DATA_USER.id == 106654 || // Camacho Herrera Andreé
        rootState.DATA_USER.id == 6003 || // Colque Tolaba Roxana Gabriela
        rootState.DATA_USER.id == 77014 || // Montenegro Zapata Brandon
        rootState.DATA_USER.id == 174163 || // Arenas Perez Nizeyda Gabriela
        rootState.DATA_USER.id == 53130 || // Tirado Padilla Carla Beatriz
        rootState.DATA_USER.id == 19025 || // Cari Quispe Benita Kenia
        rootState.DATA_USER.id == 48234 || // Urquizu Barrientos Beatriz
        rootState.DATA_USER.id == 131081 || // Romero Mamani Carol Jasmin
        rootState.DATA_USER.id == 13028 || // Nayarit Cecilia Vargas Terceros
        rootState.DATA_USER.id == 34099 || // Cossio Castillo Diana
        rootState.DATA_USER.id == 183478 || // Zambrana Uriona Claudia Cristina
        rootState.DATA_USER.id == 80210 // Chambi Choque Ximena
      );
    },
    permisosDNA(state, getters, rootState) {
      return (
        rootState.CARGO.id == 1 || // MASTER
        rootState.DATA_USER.id == 47129 || // Castillo Rospilloza Elio Diego
        rootState.DATA_USER.id == 19467 || // López Tapia Juan Ángel
        rootState.DATA_USER.id == 59716 || // Vaca Prado Valeria Del Rosario
        rootState.DATA_USER.id == 93 || // Guzman Amelia
        rootState.DATA_USER.id == 22161 || // Oropeza Choquellampa Cintia Beatriz
        rootState.DATA_USER.id == 156601 || // Lucas Adriana Aracely
        rootState.DATA_USER.id == 870 || // Nataly Soruco Sanchez
        rootState.DATA_USER.id == 178929 || // Marcela Enriqueta Aguirre Capa
        rootState.DATA_USER.id == 181832 // Nestor Abila Flores Clemente
      );
    },
    permisosResponsablesTitulaciones(state, getters, rootState) {
      return (
        rootState.CARGO.id == 1 || // MASTER
        rootState.DATA_USER.id == 12988 || // Muñoz Paula María De Los Ángeles
        rootState.DATA_USER.id == 1158 || // Peñas Avalos Silvia Laura
        rootState.DATA_USER.id == 76945 || // Villarroel Lopez Milenka Ninoska
        rootState.DATA_USER.id == 3915 || // Ibañez Hanco Catherine Carol
        rootState.DATA_USER.id == 53027 || // Salims Taboada Jalil Teofilo
        rootState.DATA_USER.id == 154092 || // Caero Ramos Gabriela
        rootState.DATA_USER.id == 51124 || // Eguez Davila Joanna Sthefany
        rootState.DATA_USER.id == 2123 || // Peñaranda Ordoñez Andreina Elena
        rootState.DATA_USER.id == 96279 || // Mamani Chambi Rocio Flora
        rootState.DATA_USER.id == 1331 || // Victoria Mendoza Carmen Julia
        rootState.DATA_USER.id == 23081 || // Tambo Villazon Dakmar Varinia
        rootState.DATA_USER.id == 149800 || // Huayllani Huanaco Sindey Rosario
        rootState.DATA_USER.id == 10289 || // Huarayo Uribe Milenka
        rootState.DATA_USER.id == 127999 || // Lozano Maraz Mirtha Fatima
        rootState.DATA_USER.id == 25406 || // Soliz Michel Laura Patricia
        rootState.DATA_USER.id == 918 || // Ochoa Arancibia Tania Irina
        rootState.DATA_USER.id == 6608 || // Lino Segovia Eduardo Luis
        rootState.DATA_USER.id == 39635 || // Hermoza Ledezma Ninfa Rubi
        rootState.DATA_USER.id == 15823 || // Burgos Flores Samira Goyita
        rootState.DATA_USER.id == 152707 || // Fabian Ayala Verania
        rootState.DATA_USER.id == 9845 || // Rodriguez Flores Alejandra Lili
        rootState.DATA_USER.id == 6003 || // Colque Tolaba Roxana Gabriela
        rootState.DATA_USER.id == 62081 || // Villarroel Ingrid Pamela
        rootState.DATA_USER.id == 173669 || // Perez Murry Marcela
        rootState.DATA_USER.id == 174163 || // Arenas Perez Nizeyda Gabriela
        rootState.DATA_USER.id == 142465 || // Padilla Rivera Andrea Veronica
        rootState.DATA_USER.id == 131081 || // Romero Mamani Carol Jasmin
        rootState.DATA_USER.id == 38311 || // Manjon Romero Erick Mauricio
        rootState.DATA_USER.id == 64723 || // Sánchez Soliz Roxana Romina
        rootState.DATA_USER.id == 13028 // Nayarit Cecilia Vargas Terceros
      );
    },
  },
};
